module.exports = __webpack_public_path__ + "img/java.67ea5c75.png";